





















































































# import settings from '@/settings'
import absences_table from '@/components/tables/absences_table'
import balance from '@/components/balance'
import n from '@/utils/notifications'
import t from '@/utils/tools'
import q from '@/graphql/query'
import m from '@/graphql/mutation'
import FileUpload from '@/components/file_upload'


export default {
    name: 'users_absences'

    components: { absences_table, balance, FileUpload }

    data: ()->
        reload: true
        can_save: false
        errors: {}
        active_names: [1]
        absence_choice_set: []
        min: 0
        step: 0.5
        clearable: true
        absence: {
            uid: ''
            user_in_charge_uid: ''
            absence_type: {uid: '', groupe: ''}
            start: ''
            start_day_part: 0
            end: ''
            end_day_part: 1
            nb_days: 0
            state: {uid: ''}
            reason: ''
        }
        choice: ['', '']
        props: {
          value: 'uid',
          label: 'label'
        }
        hours_required: ["Repos compensateur obligatoire", "Repos compensateur de remplacement", "Repos compensateur complémentaire"]
        hours_required_uids: []
        picker_options: {firstDayOfWeek:1}
        day_part_options: @$store.state.day_part_options

    computed:
        save_text: ()->
            text = "Ajouter"
            if @absence.uid != ''
                text = "Enregistrer"
            return text

        toggle_collapse_text: ()->
            text = "Ajouter une demande d'absence"
            if @active_names.length > 1
                text = "Fermer"
            return text

        toggle_collapse_icon: ()->
            class_icon = 'mdi-plus-circle-o'
            if @active_names.length > 1
                class_icon = 'mdi-close-circle-o'
            return class_icon

        duration_unity: ()->
            unity = 'de jours'
            # console.log "DURATION"
            if @choice[0] == "Repos" and @choice[1] in @hours_required_uids
                unity = 'd\'heures'
            return unity

    methods:
        has_access_right: t.has_access_right

        cascader_change: ()->
            # console.log "CASCADER CHANGE", @choice
            return

        reset_absence: ()->
            @$refs.file_upload.clearTmpFiles()
            @choice = ['', '']
            @absence = {
                uid: ''
                user_in_charge_uid: ''
                # holiday_type: t.deep_copy(@holiday_choice_set[0])
                absence_type: {uid: '', group: ''}
                start: ''
                start_day_part: 0
                end: ''
                end_day_part: 1
                nb_days: 0
                state: {uid: ''}
                reason: ''
            }
            @
            # ## try to reset completely cascader but fail: when we edit a campaign, close it, and add a new campaign ->
            # ## cascader retains the family absence...
            # console.log "RESET abs casc", @$refs.absence_cascader
            # console.log "RESET get 1", @$refs.absence_cascader.$refs.panel.getCheckedNodes()
            # @$refs.absence_cascader.$refs.panel.clearCheckedNodes()
            # console.log "RESET choice", @choice
            # console.log "RESET get 2", @$refs.absence_cascader.$refs.panel.getCheckedNodes()
            return

        get_errors: (fieldName)->
            ret = null
            if @errors[fieldName]?
                ret = @errors[fieldName][0]
            return ret

        collapse_change: (value)->
            # console.log "VUE TOGGLE ", value
            # console.log "COLLAPSE", @choice
            @errors = {}
            @reset_absence()
            return

        cancellation: (absence, text)->
            # console.log "USER ABSENCE cancellation ", absence, text
            self = @
            @$confirm("Êtes-vous sûr·e de vouloir "+text+" ?", 'Confirmation', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler'
                })
                .then ()->
                    # console.log "ABSENCE CANCEL", absence.uid, absence.state.slug
                    self.absence = absence
                    self.choice[1] = absence.absence_type.uid
                    self.save()
                .catch (cancel)->
                    self.reload = !self.reload
            return

        edit_absence: (absence)->
            @absence = t.deep_copy(absence)
            @choice = [absence.absence_type.group,absence.absence_type.uid]
            # console.log "EDIT ABSENCE", @choice
            @active_names = [1, "1"]
            @errors = {}
            # @$root.$el.scrollTop = 0
            return

        delete_absence: (absence_uid)->
            # console.log  "DELETE ABSENCE", absence_uid
            self = @
            @$confirm("Êtes-vous sûr·e de vouloir supprimer cette demande d'absence ?", 'Confirmation', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler'
                })
                .then ()->
                    # console.log "ABSENCE DELETE", absence_uid
                    m.run('delete_object', ['absence', absence_uid])
                    .then (resp)->
                        # console.log "DELETE ABSENCE", resp.body.data.absence_deletion
                        if resp.body.data.absence_deletion.ok
                            n.success()
                            self.reload = !self.reload
                        else
                            n.gql_error("users_absences: delete_absence: then", resp.body.data.absence_deletion.message)
                    .catch (resp)->
                        n.catch_error(resp, "users_absences: delete_absence()")
                .catch (cancel)->
                    return

        save: ()->
            # console.log "SAVE ABSENCE", @absence
            @absence.absence_type.uid = @choice[1]
            self = @
            m.run('save_absence', [@absence, 'users'])
            .then (resp)->
                if resp.body.data.absence_form_mutation.form_ret == 'failed'
                    return n.access_denied()
                if resp.body.data.absence_form_mutation.errors.length > 0
                    # console.log "ERRORS", resp.body.data.absence_form_mutation.errors
                    self.errors = resp.body.data.absence_form_mutation.errors.reduce(
                        (acc, el)->
                            acc[el.field] = el.messages
                            return acc
                    ,{})
                    n.form_error()
                else
                    self.errors = {}
                    await self.$refs.file_upload.save_from_parent(
                      resp.body.data.absence_form_mutation.form_ret)
                    n.success()
                    self.reset_absence()
                    self.active_names = [1]
                    self.reload = !self.reload
            .catch (resp)->
                n.catch_error(resp, "users_absences: save()")

        get_absence_choice_set: ()->
            self = @
            # q.run('get_type_set', ['holiday_choice'])
            q.run('get_absence_choice_set', [])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("users_absences: get_absence_choice_set: then" ,e.message)
                else
                    # console.log "GET ABSENCE CHOICES : ", resp.body.data.absence_choice_set
                    # self.absence_choice_set = resp.body.data.absence_choice_set
                    # group_set = ['Santé', 'Famille', 'Repos', 'Formation', 'Absences légales', 'Chômage', 'Autres']
                    sante = {uid:'Santé', label:'Santé', children:[]}
                    famille = {uid:'Famille', label:'Famille', children:[]}
                    repos = {uid:'Repos', label:'Repos', children:[]}
                    formation = {uid:'Formation', label:'Formation', children:[]}
                    absences = {uid:'Absences légales', label:'Absences légales', children:[]}
                    chomage = {uid:'Chômage', label:'Chômage', children:[]}
                    autres = {uid:'Autres', label:'Autres', children:[]}
                    sante.children = resp.body.data.absence_choice_set.filter (x)-> x.group == 'Santé'
                    famille.children = resp.body.data.absence_choice_set.filter (x)-> x.group == 'Famille'
                    repos.children = resp.body.data.absence_choice_set.filter (x)-> x.group == 'Repos'
                    formation.children = resp.body.data.absence_choice_set.filter (x)-> x.group == 'Formation'
                    absences.children = resp.body.data.absence_choice_set.filter (x)-> x.group == 'Absences légales'
                    chomage.children = resp.body.data.absence_choice_set.filter (x)-> x.group == 'Chômage'
                    autres.children = resp.body.data.absence_choice_set.filter (x)-> x.group == 'Autres'
                    # console.log "CASCADER ", self.absence_choice_set
                    self.hours_required_uids = repos.children
                        .filter (x)->
                            if x.label in self.hours_required
                                return x
                        .map (x)->
                            return x.uid
                    # console.log "HOURS REQUIRED ", self.hours_required_uids
                    self.absence_choice_set = [sante, famille, repos, formation, absences, chomage, autres]
            .catch (resp)->
                n.catch_error(resp, "users_absences: get_absence_choice_set()")

    beforeMount: ()->
        @get_absence_choice_set()
}
